import {
  Globe, Code2, ShoppingCart, MapPin, Building2, Megaphone, Target,
  Search, Settings2, Palette, Share2, PenTool, TrendingUp, Sparkles,
  Bot, Wrench, HeartPulse, UtensilsCrossed, Hotel, Stethoscope, Smile,
  Scissors, Flower2, GraduationCap, Home, Store, HardHat, Sofa, Factory,
  Cpu, Briefcase, Compass, Ruler, LayoutGrid, Rocket, LineChart,
  ShieldCheck, Users, Wallet, Award, Gauge, Headphones,
} from "lucide-react";

export const CONTACT = {
  name: "DiziTeQ Innovative Solutions",
  phone: "+91 81232 52171",
  phoneRaw: "+918123252171",
  email: "hello@diziteq.in",
  website: "https://diziteq.in",
  city: "Bengaluru, Karnataka, India",
  whatsapp:
    "https://wa.me/918123252171?text=Hi%20DiziTeQ%20Innovative%20Solutions,%20I'm%20interested%20in%20your%20digital%20marketing%20services.%20Please%20contact%20me.",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Industries", to: "/industries" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Case Studies", to: "/case-studies" },
  { label: "Process", to: "/process" },
  { label: "Pricing", to: "/pricing" },
  { label: "Blog", to: "/blog" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const STATS = [
  { value: 250, suffix: "+", label: "Projects Delivered" },
  { value: 4.9, suffix: "/5", label: "Average Client Rating", decimals: 1 },
  { value: 320, suffix: "%", label: "Avg. Lead Growth" },
  { value: 12, suffix: "+", label: "Years of Expertise" },
];

export const CLIENT_LOGOS = [
  "Nova Dental", "Urban Spice", "Casa Interiors", "GreenLeaf Clinic",
  "Prime Realty", "Bloom Salon", "Apex Legal", "Metro Motors",
  "Zenith CA", "Lumen Cafe", "Vertex Build", "Aria Spa",
];

export const SERVICES = [
  { icon: Globe, title: "Website Design", slug: "website-design", desc: "Pixel-perfect, conversion-first designs that build instant trust." },
  { icon: Code2, title: "Website Development", slug: "website-development", desc: "Fast, secure, scalable builds engineered for Core Web Vitals." },
  { icon: ShoppingCart, title: "eCommerce Development", slug: "ecommerce", desc: "High-converting online stores that turn browsers into buyers." },
  { icon: MapPin, title: "Local SEO", slug: "local-seo", desc: "Dominate the Google Map Pack and get found by nearby customers." },
  { icon: Building2, title: "Google Business Profile", slug: "gbp-optimization", desc: "Full GBP optimization to rank higher on Google Maps." },
  { icon: Target, title: "Google Ads", slug: "google-ads", desc: "Intent-driven campaigns that generate qualified leads on demand." },
  { icon: Megaphone, title: "Meta Ads", slug: "meta-ads", desc: "Scroll-stopping Facebook & Instagram ads that scale profitably." },
  { icon: Search, title: "SEO", slug: "seo", desc: "Organic growth engines built on data and lasting authority." },
  { icon: Settings2, title: "Technical SEO", slug: "technical-seo", desc: "Site health, speed and crawlability tuned to perfection." },
  { icon: Palette, title: "Brand Identity", slug: "brand-identity", desc: "Distinctive brands that customers remember and trust." },
  { icon: Share2, title: "Social Media Marketing", slug: "social-media", desc: "Consistent, on-brand content that grows your community." },
  { icon: PenTool, title: "Content Marketing", slug: "content-marketing", desc: "Story-led content that attracts, educates and converts." },
  { icon: TrendingUp, title: "Performance Marketing", slug: "performance-marketing", desc: "Full-funnel campaigns optimized for measurable ROI." },
  { icon: Sparkles, title: "Graphic Design", slug: "graphic-design", desc: "Premium visuals across every touchpoint of your brand." },
  { icon: Bot, title: "AI Automation", slug: "ai-automation", desc: "Smart automations that save time and capture more leads." },
  { icon: Wrench, title: "Website Maintenance", slug: "maintenance", desc: "Ongoing care, updates and support to keep you at peak." },
];

export const INDUSTRIES = [
  { icon: HeartPulse, title: "Healthcare" },
  { icon: UtensilsCrossed, title: "Restaurants" },
  { icon: Hotel, title: "Hotels" },
  { icon: Stethoscope, title: "Clinics" },
  { icon: Smile, title: "Dental" },
  { icon: Sparkles, title: "Beauty" },
  { icon: Scissors, title: "Salon" },
  { icon: Flower2, title: "Spa" },
  { icon: GraduationCap, title: "Education" },
  { icon: Home, title: "Real Estate" },
  { icon: Store, title: "Retail" },
  { icon: HardHat, title: "Construction" },
  { icon: Sofa, title: "Interior Design" },
  { icon: Factory, title: "Manufacturing" },
  { icon: Cpu, title: "Technology" },
  { icon: Briefcase, title: "Professional Services" },
];

export const WHY_CHOOSE = [
  { icon: Award, title: "Premium Quality", desc: "Award-worthy craft on every project, no compromises." },
  { icon: Users, title: "Experienced Team", desc: "Specialists across design, dev, SEO and paid media." },
  { icon: Wallet, title: "Transparent Pricing", desc: "Clear scopes and no hidden fees. Ever." },
  { icon: MapPin, title: "Local SEO Experts", desc: "Deep expertise ranking Bengaluru businesses locally." },
  { icon: ShieldCheck, title: "Google Certified", desc: "Certified specialists in Ads and Analytics." },
  { icon: Gauge, title: "Performance Focused", desc: "Every decision tied to measurable business growth." },
  { icon: Headphones, title: "Long-Term Support", desc: "A partner invested in your growth for the long run." },
];

export const PROCESS = [
  { icon: Compass, title: "Discover", desc: "We learn your business, market and goals inside-out." },
  { icon: Target, title: "Strategy", desc: "A data-backed roadmap tailored to measurable outcomes." },
  { icon: Palette, title: "Design", desc: "Premium interfaces crafted around your customers." },
  { icon: Code2, title: "Development", desc: "Fast, secure builds engineered for scale and speed." },
  { icon: LineChart, title: "Optimization", desc: "We test, refine and tune for maximum conversions." },
  { icon: Rocket, title: "Launch", desc: "A flawless go-live with everything tracked and ready." },
  { icon: TrendingUp, title: "Growth", desc: "Continuous improvement to compound your results." },
];

export const PORTFOLIO = [
  { title: "Nova Dental Studio", category: "Healthcare", tag: "Website + Local SEO", image: "/portfolio/nova-dental.jpeg", result: "+280% appointment bookings" },
  { title: "Urban Spice Kitchen", category: "Restaurants", tag: "Branding + Meta Ads", image: "/portfolio/urban-spice.jpeg", result: "3.2x online orders" },
  { title: "Casa Interiors", category: "Interior Design", tag: "Website + SEO", image: "/portfolio/casa-interiors.jpeg", result: "Page 1 for 40+ keywords" },
  { title: "Prime Realty Group", category: "Real Estate", tag: "Google Ads", image: "/portfolio/prime-realty.jpeg", result: "-42% cost per lead" },
  { title: "Bloom Salon & Spa", category: "Beauty", tag: "Social + GBP", image: "/portfolio/bloom-salon.jpeg", result: "+190% walk-ins" },
  { title: "Apex Legal Partners", category: "Professional Services", tag: "Website + SEO", image: "/portfolio/apex-legal.jpeg", result: "4x qualified enquiries" },
];

export const PORTFOLIO_FILTERS = ["All", "Healthcare", "Restaurants", "Real Estate", "Beauty", "Professional Services", "Interior Design"];

export const CASE_STUDIES = [
  {
    title: "Nova Dental Studio",
    industry: "Healthcare",
    image: "/portfolio/nova-dental.jpeg",
    challenge: "A premium dental clinic in Indiranagar was invisible on Google Maps and relied entirely on word-of-mouth for new patients.",
    solution: "We rebuilt their website for speed and trust, fully optimized their Google Business Profile, and launched a review-generation system paired with local landing pages.",
    results: [
      { value: 280, suffix: "%", label: "More bookings" },
      { value: 1, prefix: "#", label: "Map Pack ranking" },
      { value: 4.9, suffix: "★", label: "Google rating", decimals: 1 },
    ],
  },
  {
    title: "Urban Spice Kitchen",
    industry: "Restaurants",
    image: "/portfolio/urban-spice.jpeg",
    challenge: "A growing restaurant brand struggled with inconsistent branding and low return on ad spend across Meta platforms.",
    solution: "A full brand identity refresh, a mouth-watering content system, and tightly targeted Meta ad funnels with retargeting.",
    results: [
      { value: 3.2, suffix: "x", label: "Online orders", decimals: 1 },
      { value: 58, suffix: "%", label: "Lower CPA" },
      { value: 210, suffix: "%", label: "ROAS increase" },
    ],
  },
  {
    title: "Prime Realty Group",
    industry: "Real Estate",
    image: "/portfolio/prime-realty.jpeg",
    challenge: "High ad costs and unqualified leads were draining the marketing budget of this Bengaluru real estate firm.",
    solution: "Rebuilt Google Ads structure, added conversion tracking, and created high-intent landing pages with instant WhatsApp follow-up.",
    results: [
      { value: 42, suffix: "%", label: "Lower cost/lead" },
      { value: 3.5, suffix: "x", label: "Qualified leads", decimals: 1 },
      { value: 24, suffix: "hrs", label: "Faster response" },
    ],
  },
];

export const TESTIMONIALS = [
  { name: "Dr. Ananya Rao", business: "Nova Dental Studio", industry: "Healthcare", rating: 5, quote: "DiziTeQ transformed how patients find us. We went from invisible to fully booked within three months. Truly premium work.", result: "+280% bookings" },
  { name: "Rahul Menon", business: "Urban Spice Kitchen", industry: "Restaurants", rating: 5, quote: "Our brand finally looks as good as our food tastes. The Meta ads they run pay for themselves several times over.", result: "3.2x orders" },
  { name: "Sneha Kapoor", business: "Casa Interiors", industry: "Interior Design", rating: 5, quote: "Beautiful website, and we now rank on page one for dozens of keywords. Leads come in on autopilot.", result: "40+ keywords ranked" },
  { name: "Vikram Shetty", business: "Prime Realty Group", industry: "Real Estate", rating: 5, quote: "The team is transparent, sharp and genuinely invested in our growth. Cost per lead dropped dramatically.", result: "-42% cost/lead" },
  { name: "Fatima Noor", business: "Bloom Salon & Spa", industry: "Beauty", rating: 5, quote: "Our calendar is full of new clients every week. The Google profile work alone was worth it.", result: "+190% walk-ins" },
];

export const PRICING = [
  {
    name: "Starter",
    price: "₹24,999",
    period: "/ project",
    tagline: "For new businesses building a premium online presence.",
    popular: false,
    features: [
      "5-page premium website",
      "Mobile-first responsive design",
      "Basic on-page SEO",
      "Google Business Profile setup",
      "WhatsApp & call integration",
      "Contact form + lead capture",
      "1 month support",
    ],
    cta: "Get Started",
  },
  {
    name: "Growth",
    price: "₹59,999",
    period: "/ project",
    tagline: "For established businesses ready to scale leads.",
    popular: true,
    features: [
      "Everything in Starter",
      "Up to 12 pages + blog",
      "Advanced Local SEO campaign",
      "Google Business Profile optimization",
      "Google Ads or Meta Ads setup",
      "Conversion tracking & analytics",
      "Monthly performance reporting",
      "3 months priority support",
    ],
    cta: "Book Consultation",
  },
  {
    name: "Enterprise",
    price: "Custom",
    period: "",
    tagline: "For brands wanting a full-scale growth partner.",
    popular: false,
    features: [
      "Everything in Growth",
      "Custom web & eCommerce builds",
      "Full-funnel performance marketing",
      "Dedicated account manager",
      "AI automation & CRM integration",
      "Brand identity & content system",
      "Quarterly strategy reviews",
      "Priority long-term support",
    ],
    cta: "Talk to Us",
  },
];

export const FAQS = [
  { q: "Where is DiziTeQ located and do you work with businesses across Bengaluru?", a: "We are a Bengaluru-based digital marketing agency and we work with local businesses across the city and all of India. Most of our work is delivered remotely with regular strategy calls." },
  { q: "How long does it take to build a website?", a: "A premium website typically takes 2 to 4 weeks depending on scope. We'll share a clear timeline during your free consultation." },
  { q: "How soon will I see results from Local SEO?", a: "Local SEO and Google Business Profile optimization usually start showing movement within 4 to 8 weeks, with compounding results over 3 to 6 months." },
  { q: "Do you offer transparent pricing?", a: "Absolutely. Every engagement comes with a clear scope, deliverables and pricing. No hidden fees, ever." },
  { q: "Which industries do you specialise in?", a: "We work with clinics, hospitals, restaurants, salons, spas, real estate, interior designers, law firms, CA firms, retail, manufacturing, startups and more." },
  { q: "Do you provide ongoing support after launch?", a: "Yes. We offer website maintenance and ongoing marketing retainers so your growth never stalls after launch." },
  { q: "Can you manage my Google Ads and Meta Ads?", a: "Yes. Our Google-certified team plans, launches and optimizes paid campaigns focused on measurable ROI and qualified leads." },
];

export const ABOUT_VALUES = [
  { icon: Sparkles, title: "Craft Over Clutter", desc: "We believe premium simplicity converts better than noise." },
  { icon: LineChart, title: "Growth Is The Metric", desc: "Beauty matters, but results matter more. We measure everything." },
  { icon: ShieldCheck, title: "Trust By Default", desc: "Transparent, honest and accountable in every engagement." },
  { icon: Rocket, title: "Always Improving", desc: "We test, learn and iterate to keep you ahead of the market." },
];
